import immutable from 'immutable';
import { SUBSCRIPTION_MESSAGE_TYPE } from 'util/config/constant';
import {
  NEW_MESSAGE_FOR_CLEANING_REPORT_ADDED,
  NEW_MESSAGE_FOR_NOTIFICATION_ADDED
} from './action';

const init = () => {
  const initValue = immutable.fromJS({
    message: undefined
  });

  return initValue.set('message', {
    messageObjects: {},
    newMessageId: null,
    totalCount: 0
  });
};

export default function subscriptionReducer(state = init(), action) {
  switch (action.type) {
    case NEW_MESSAGE_FOR_NOTIFICATION_ADDED: {
      const {
        payload: { messageId, data }
      } = action;

      return state.update('message', (message) => ({
        ...message,
        newMessageId: messageId,
        totalCount: message.totalCount + 1,
        messageObjects: {
          ...message.messageObjects,
          [messageId]: {
            type: SUBSCRIPTION_MESSAGE_TYPE.NOTIFICATION,
            data
          }
        }
      }));
    }

    case NEW_MESSAGE_FOR_CLEANING_REPORT_ADDED: {
      const {
        payload: { messageId, data }
      } = action;

      return state.update('message', (message) => ({
        ...message,
        newMessageId: messageId,
        totalCount: message.totalCount + 1,
        messageObjects: {
          ...message.messageObjects,
          [messageId]: {
            type: SUBSCRIPTION_MESSAGE_TYPE.CLEANING_REPORT,
            data
          }
        }
      }));
    }

    default:
      return state;
  }
}
